import Menu1 from '../../components/menu';
import Main from "../../components/main";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { bootstrapPermissions, hasPermissionCache } from '../../util/permission';
function Home(){
    const token = localStorage.getItem('token') 
    const navigate = useNavigate()
    const toLogin = ()=>{
        navigate('/login')
    }
    useEffect(() => {
        // 使用浏览器的 API 更新页面标题
            if(token == null){
                toLogin()
            } else if (!hasPermissionCache()) {
                bootstrapPermissions().catch((error) => {
                    console.error('获取权限失败', error);
                });
            }
    }, []);
    return(
        <>
            <Menu1 />
            <Main />
        </>
    )
}
  

    
  export default Home